import { useQuery } from '@apollo/client';
import ReactHTMLParser from 'react-html-parser';

import { GET_PAGE_BY_SLUG } from '../../http/apollo-queries';

import { useThemeContext } from '../../context/Theme';

import { AccountNav } from '../Account/AccountNav';
import { Loading, Card } from '../../components/UI';

const Contacts = () => {
  const { theme } = useThemeContext();

  const { data: { getPageBySlug: page } = {}, loading } = useQuery(
    GET_PAGE_BY_SLUG,
    {
      variables: {
        slug: 'contact',
      },
    }
  );

  const socialIcons = {
    facebook: 'https://www.facebook.com/merlininvestor',
    instagram: 'https://www.instagram.com/merlininvestor/',
    twitter: 'https://twitter.com/Merlin_Investor',
    tiktok: 'https://www.tiktok.com/@merlininvestor',
    discord: 'https://discord.gg/mQsCTPkKuj',
    youtube: 'https://www.youtube.com/channel/UCZWsRZNh5SRM6H5IPwteKFA',
    linkedin: 'https://www.linkedin.com/company/merlininvestor',
  };

  return (
    <div className="flex flex-col w-full bg-white text-black items-center dark:bg-black-real dark:text-white">
      <div className="w-full lg:w-2/3X">
        <AccountNav />
        <Loading className={'mt-4 mx-auto'} status={loading} />
        {page && (
          <Card className="my-4" title={page.title}>
            <div className="flex flex-col">
              <div className="mb-5">{ReactHTMLParser(page.content)}</div>
              <div className="flex justify-end gap-5 p-5">
                {Object.entries(socialIcons).map((social, index) => (
                  <a
                    href={social[1]}
                    target={'_blank'}
                    key={index}
                    rel={'noreferrer'}
                  >
                    <img
                      className="flex w-5 h-5 cursor-pointer"
                      key={social[0]}
                      src={`/icons/social-icons/${social[0]}-${theme}.svg`}
                      alt={social[0]}
                    />
                  </a>
                ))}
              </div>
            </div>
          </Card>
        )}
      </div>
    </div>
  );
};

export default Contacts;
